import React from "react";
import { Check, ArrowRight } from "lucide-react";

export const PricingCard = ({
  testIdCard,
  testIdCta,
  eyebrow,
  title,
  price,
  subPrice,
  duration,
  bullets = [],
  ctaLabel,
  onCta,
  accent = false,
}) => {
  return (
    <article
      data-testid={testIdCard}
      className={`bg-white rounded-2xl p-7 sm:p-8 border ${
        accent ? "border-[#0E7C7B]/40" : "border-[#E8E2D4]"
      } hr-card-shadow flex flex-col`}
    >
      {eyebrow && (
        <p className="text-[11px] tracking-[0.22em] uppercase font-semibold text-[#0E7C7B]">
          {eyebrow}
        </p>
      )}
      <h3 className="font-serif text-2xl sm:text-[28px] leading-snug text-[#1F2E4D] mt-2">
        {title}
      </h3>
      <div className="flex items-baseline gap-2 mt-4">
        <span className="font-serif text-3xl sm:text-4xl text-[#1F2E4D]">
          {price}
        </span>
        {subPrice && (
          <span className="text-sm text-[#4A5568]">/ {subPrice}</span>
        )}
      </div>
      {duration && (
        <p className="text-sm text-[#4A5568] mt-1">{duration}</p>
      )}

      <ul className="mt-6 space-y-3 flex-1">
        {bullets.map((b, i) => (
          <li key={i} className="flex items-start gap-3 text-[15px] text-[#1F2E4D]">
            <span className="mt-0.5 inline-flex items-center justify-center w-5 h-5 rounded-full bg-[#E0EBEB]">
              <Check className="w-3 h-3 text-[#0E7C7B]" aria-hidden />
            </span>
            <span className="leading-relaxed">{b}</span>
          </li>
        ))}
      </ul>

      {ctaLabel && onCta && (
        <button
          type="button"
          onClick={onCta}
          data-testid={testIdCta}
          className="mt-8 inline-flex items-center justify-between gap-3 bg-[#0E7C7B] hover:bg-[#0b6362] text-white rounded-full px-6 py-4 font-medium transition-colors hr-pill-shadow"
        >
          <span>{ctaLabel}</span>
          <ArrowRight className="w-4 h-4" aria-hidden />
        </button>
      )}
    </article>
  );
};

export default PricingCard;
